import glamorous from "glamorous";

const FeatureButton = glamorous.a({
  // background: "#dc594b",
  background: "linear-gradient(to bottom, #dc594b, #dc594b)",
  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.25)",
  color: "#fff",
  display: "inline-block",
  fontSize: 20,
  fontWeight: 600,
  textDecoration: "none",
  textTransform: "uppercase",
  padding: "0.5rem 1.25rem",
  transition: "0.25s",
  [":hover"]: {
    background: "linear-gradient(to bottom, #dc594b, #dc6862)",
    cursor: "pointer",
    transform: "scale(1.02, 1.02)",
    transition: "0.25s"
  }
});

export default FeatureButton;



// WEBPACK FOOTER //
// ./src/components/FeatureButton/index.js